export enum SaleOrderStatus {
  QUOTE_IN_PROGRESS = 'MV1',
  QUOTE_SUBMITTED = 'MV2',
  ORDER_CREATED = 'MV4',
  ORDER_CONFIRMED = 'MV3',
  ORDER_WAITING_PAYMENT = 'E',
  ORDER_IN_PROGRESS = 'W',
  ORDER_ISSUED = 'A',
  CANCELLED = 'T'
}

export const SALE_ORDER_STATUSES = [
  {
    label: 'Pakkumuse ootel',
    value: SaleOrderStatus.QUOTE_IN_PROGRESS
  },
  {
    label: 'Kinnitamise ootel',
    value: SaleOrderStatus.QUOTE_SUBMITTED
  },
  {
    label: 'Tellimus esitatud',
    value: SaleOrderStatus.ORDER_CREATED
  },
  {
    label: 'Tellimus kinnitatud',
    value: SaleOrderStatus.ORDER_CONFIRMED
  },
  {
    label: 'Ettemaks tasumata',
    value: SaleOrderStatus.ORDER_WAITING_PAYMENT
  },
  {
    label: 'Tellimus töös',
    value: SaleOrderStatus.ORDER_IN_PROGRESS
  },
  {
    label: 'Tellimus väljastatud',
    value: SaleOrderStatus.ORDER_ISSUED
  },
  {
    label: 'Tühistatud',
    value: SaleOrderStatus.CANCELLED
  }
];

export interface SaleOrder {
  externalId: number;
  uid: string;
  objectId: string;
  docNumber: string;
  docState: string;
  docStateName: string;
  canChange: boolean;
  isQuote: boolean;
  authorizationNumber: string;
  validUntil: string;
  driverCode: string;
  driverName: string;
  carCode: string;
  carName: string;
  transporterCode: string;
  transporterName: string;
  customerCode: string;
  customerName: string;
  productOwnerExternalId: number;
  productOwnerName: string;
  location: {
    externalId: number;
    name: string;
    address: string;
    city: string;
    zip: string;
  };
  rows: SaleOrderRow[];
  deliveryDate?: any;
  desiredDeliveryDate?: string;
  fileName?: string;
  authStatus?: string;
  orderDate?: string;
  orderAdditionalInfo?: string;
}

export interface SaleOrderRow {
  rowNo: number;
  productName: string;
  quantity: number;
  batchId: number;
  price?: number;
}

export interface SaleOrderProduct {
  productId: number;
  batchId: number;
  exciseType: string;
  prodBrandId: string;
  prodBrandName: string;
  name: string;
  selected?: boolean;
  fuelAmount?: number;
  specialFuel: boolean;
  invalid?: boolean;
}

export interface SaleOrderCustomer {
  name: string;
  searchCode: string;
  salesRepresentativeId: string;
  salesRepresentativeName: string;
  salesmanId: string;
  salesmanName: string;
  locations: SaleOrderCustomerLocation[];
}

export interface SaleOrderCustomerLocation {
  customerLocationId: number;
  county: string;
  city: string;
  mainAddress: string;
  zipCode: string;
}

export interface SaleOrderLoadingProvider {
  id: number;
  name: string;
  objectId: string;
  searchCode: string;
}

export enum SaleOrderSortFields {
  ID = 'uid',
  STATUS = 'docState',
  DATE = 'validUntil',
  ORDER_DATE = 'orderDate',
  DELIVERY_DATE = 'desiredDeliveryDate'
}

export interface CreateSaleOrderRequest {
  customerLocationId?: number;
  loadingProvider?: string;
  objectId?: string;
  carrier: string;
  vehicleCode?: string;
  driver?: string;
  deliveryDate: string;
  notes?: string;
  stateId?: string;
  rows: SaleOrderRowRequest[];
  paymentDeadline?: number;
  notificationReceiverEmail?: string;
}

export interface SaleOrderRowRequest {
  batchAmount: number;
  remoteBatchId: number;
  specialFuel: boolean;
}